import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { PhoneCall } from "lucide-react";
import { CONTACT } from "@/lib/data";

export default function StickyCTA() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 900);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname === "/contact") return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          className="fixed bottom-6 left-6 z-30 hidden md:flex"
          data-testid="sticky-cta"
        >
          <Link
            to="/contact"
            className="glass rounded-full pl-2 pr-5 py-2 flex items-center gap-3 hover:border-[#10B981]/40 transition-colors"
          >
            <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0"
              style={{ background: "linear-gradient(120deg, #1E3A8A, #10B981)" }}>
              <PhoneCall className="w-4 h-4 text-white" />
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-inter text-[11px] text-white/50 uppercase tracking-[0.16em]">Free Consult</span>
              <span className="font-poppins text-white text-sm font-medium">{CONTACT.phone}</span>
            </span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
